/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { IDataTableColumn } from '../MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import './CarbonDetailTabBreakdownBySiteTheme.scss';
import { IUtilityCostSavingsData } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { ColumnDetailsEntity } from './ICarbonDetailTabBreakdownProps';
import UtilityCellDataRenderer from '../../DetailKPIWidgets/DataTableComponents/UtilityCost/UtilityCellDataRenderer';

export interface IUtilityCostDetailTabBreakdownBySiteProps {
  siteData: IUtilityCostSavingsData[];
  utilityCostCurrency: string;
  columnDetails: ColumnDetailsEntity[];
}

const UtilityCostDetailTabBreakdownBySite = (
  props: IUtilityCostDetailTabBreakdownBySiteProps
) => {
  const { siteData, columnDetails, utilityCostCurrency } = props;
  const cellDataRenderer = (cellData: ICellData) => {
    const utilityProps = {
      cellData,
      utilityCostCurrency
    };
    return <UtilityCellDataRenderer {...utilityProps} />;
  };

  return (
    <DataTable className="Savingtable" data={siteData}>
      {columnDetails.map((column: IDataTableColumn) => {
        return (
          <DataTable.Column
            key={column.field}
            field={column.field}
            header={column.header}
            sortable={column.sortable}
            renderer={cellDataRenderer}
            className={column.className}
            initialWidth={column.initialWidth}
          />
        );
      })}
    </DataTable>
  );
};
export default UtilityCostDetailTabBreakdownBySite;
